module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "modal modal--spacious",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$router.go(-1)
      }
    }
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_c('h2', {
    staticClass: "modal__title title--general title--2"
  }, [_vm._v("\n\t\t\t\t\t\tForgotten password\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "modal__close-button",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('svg-icon', {
    staticClass: "modal__close-button__icon",
    attrs: {
      "icon": "x"
    }
  })], 1)]), _vm._v(" "), _c('form', {
    staticClass: "modal__section",
    class: {
      'has-error': _vm.errors.any()
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.requestResetPassword()
      }
    }
  }, [(!_vm.isEmailSent) ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "label": "E-mail",
      "data-vv-validate-on": "blur",
      "type": "text",
      "name": "email",
      "error-messages": _vm.errors.has('email') ? 'Enter your email' : [],
      "outlined": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "type": "submit",
      "loading": _vm.isLoading,
      "disabled": _vm.isLoading,
      "color": "primary"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tRequest password reset\n\t\t\t\t\t\t")])] : _c('p', [_vm._v("\n\t\t\t\t\t\tCheck your email address to reset your password\n\t\t\t\t\t")])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dfa0f57","hasScoped":false}!./app/components/forgot-password-modal/template.html
// module id = 367
// module chunks = 0